import { KbVector } from '@models/classes/primitives/kb-vector';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { ILinearPatternFeature } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { ALL_GEOMETRY } from './feature';
import { PatternFeature } from './pattern-feature';

@Kb3dModel({
    token: Token.LinearPatternFeature,
})
export class LinearPatternFeature extends PatternFeature implements ILinearPatternFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    translation: KbVector;
}

export function isLinearPattern(o: Kb3dObject): o is LinearPatternFeature {
    return instanceOf(o, Token.LinearPatternFeature);
}
